import { createVuetify } from "vuetify";
import "vuetify/styles";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Import locale if needed (optional)
import { fa } from "vuetify/locale";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
  },
  defaults: {
    global: {
      dir: "rtl", // Set default direction to RTL
    },
  },
  locale: {
    locale: "fa", // Set the default locale
    messages: { fa }, // Use Farsi locale (optional)
  },
});

export default vuetify;
